import type { CloudinaryTransformConfig } from '@garnish/media';

// ─────────────────────────────────────────────────────────────────────────────

export const WIDTH_MD = 310;
export const HEIGHT_MD = 140;

export const WIDTH_LG = 350;
export const HEIGHT_LG = 140;

// ─────────────────────────────────────────────────────────────────────────────

const CLOUDINARY_CONFIG_BASE: CloudinaryTransformConfig = {
  crop: 'crop',
  height: 0.6,
  width: 0.6,
};

export const CLOUDINARY_CONFIG_MD: CloudinaryTransformConfig = [
  CLOUDINARY_CONFIG_BASE,
  { height: HEIGHT_MD },
];
export const CLOUDINARY_CONFIG_LG: CloudinaryTransformConfig = [
  CLOUDINARY_CONFIG_BASE,
  { height: HEIGHT_LG },
];
